module.exports = __webpack_public_path__ + "static/media/corporate-services-img27.9f77c35e.jpg";